import { v4 as uuid } from 'uuid';
import { BaseNetworkLog } from './base-network-log';
import { NetworkLogStatus } from '../types';

export class InitNetworkLog extends BaseNetworkLog {
  public status = NetworkLogStatus.INIT as const;

  constructor() {
    const id = uuid();
    super(id);
  }
}
